import { calcDisplaySafeHeight } from './helpers';
import { documentObserver, observerCallback } from '@/helpers/fixedBody.js';

import.meta.glob('../src/components/**/index.js', {
    import: 'default',
    eager: true,
});

document.addEventListener('DOMContentLoaded', () => {
    calcDisplaySafeHeight();
    observerCallback();
    documentObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
    });
    document.dispatchEvent(new Event(window.B2BCabinetUI.events.load));
});

window.B2BCabinetUI = {
    language: 'en',
    events: {
        load: 'B2BCabinetUILoaded',
    },
};
